import React, { Fragment, useEffect } from 'react';
import './Home.scss';
import MouseTracker from '../../components/mouse_tracker/MouseTracker';
import Modal from 'react-modal';
import GridGallery from '../../components/grid_gallery/GridGallery';
import BrandColab from '../../components/brand_colab/BrandColab';

export default function Home() {

  const videoRefHome = React.useRef<HTMLVideoElement>(null);
  const buttonRefHome = React.useRef<HTMLButtonElement>(null);



  function handlePlay() {

    if (videoRefHome.current) {
      videoRefHome.current.play().then(() => {
      }).catch(() => {
        if (buttonRefHome.current) {
          buttonRefHome.current.click();
        }
      });
    }
  }
  useEffect(() => {
    handlePlay()
    // eslint-disable-next-line 
  }, [])

  Modal.setAppElement('#root');
  return (
    <Fragment >
      <div className='video-dissolve-in'>
        <video ref={videoRefHome} className='main-video' muted controls={false} loop playsInline src={`/assets/videos/${window.innerWidth >= 460 ? "loop_video.mp4" : "loop_video_mobile.mp4"}`}></video>
        <div data-aos="fade" className='main-text'>
          {/* <div className='main-text-small'>Turning pixels into </div>
          <div className='main-text-big'>smiles</div> */}
          <button style={{ display: "none" }} ref={buttonRefHome} onClick={handlePlay}>PLAY</button>
        </div>
        <GridGallery />
        <BrandColab />
      </div>
      <MouseTracker />
    </Fragment>
  );
}
